import { useQuery } from '@tanstack/react-query';

import { useSession } from '@/compositions/hooks/useSession';
import { NO_INSTITUTION_ROLES } from '@/services/institution-roles/institution-roles.derive';
import type { InstitutionRoles } from '@/services/institution-roles/institution-roles.derive';
import { institutionRolesKeys } from '@/services/institution-roles/institution-roles.keys';
import { institutionRolesService } from '@/services/institution-roles/institution-roles.service';

/**
 * O tipo de conta, para a barra e o menu: participa de um QG? É dona de uma
 * instituição?
 *
 * Mora em `compositions/` pelo mesmo motivo de `usePlatformAdmin`: o consumidor
 * é `components/layouts`, que não importa de `modules/`. **Convidado nem
 * pergunta.** Enquanto a resposta não chega, vale "conta comum" — a barra e o
 * menu aparecem já na forma padrão e trocam um instante depois, em vez de
 * esperar a rede.
 */
export function useInstitutionRoles(): InstitutionRoles {
  const { session } = useSession();
  const profileId = session?.userId;

  const { data } = useQuery({
    queryKey: institutionRolesKeys.mine(profileId ?? 'guest'),
    queryFn: () => institutionRolesService.mine(profileId as string),
    enabled: Boolean(profileId),
    staleTime: 60_000,
  });

  return data ?? NO_INSTITUTION_ROLES;
}
